import { render, staticRenderFns } from "./paymentResult.vue?vue&type=template&id=7953672a&scoped=true&"
import script from "./paymentResult.vue?vue&type=script&lang=js&"
export * from "./paymentResult.vue?vue&type=script&lang=js&"
import style0 from "./paymentResult.vue?vue&type=style&index=0&id=7953672a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953672a",
  null
  
)

export default component.exports